const apiMixin = (Base = null) => class extends Base {

	injectApi(api) {
		this.api = api;
	}

};

export default apiMixin;
